import React from 'react';
import { Page, View, Image } from '@react-pdf/renderer'; 
import Header from './Header'; 
import Footer from './Footer'; 
import styles from './PagesStyle/Page1Styles'; 

const Page1 = ({ formData, companyLogo }) => (
  <Page size="LETTER" style={styles.pagePage1}>
    <Header companyLogo={companyLogo}  formData={formData}/>
    
    {/* First Image */}
    <View style={styles.contentImgDocPage1}>
      <Image
        style={styles.ImgdocPage1}
        src="/doc1.png"
      />
    </View>

    <Footer /> 
  </Page>
);

export default Page1;